import { createContext, useContext } from "react";

interface FormStateContextType {
  validationErrorsWithoutControl: string[][];
  disableSubmit: boolean;
  setDisableSubmit: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FormStateContext = createContext<FormStateContextType>({
  validationErrorsWithoutControl: [],
  disableSubmit: false,
  setDisableSubmit: () => {},
});

export const useFormState = () => {
  const context = useContext(FormStateContext);
  if (!context) {
    throw new Error(
      "useFormState must be used within a FormStateContext provider",
    );
  }
  return context;
};
